import Grid from '@material-ui/core/Grid'
import User from 'EurestoClass/User'
import Recherche from 'EurestoComponents/Recherche'
import moment from 'moment'
import React from 'react'
import Search from '../Search/Dbm'




moment.locale('fr')

export default class extends React.Component {

  constructor (props) {
    super(props)
  }

  render () {
    const columns = [
      { Header: 'id', accessor: 'id', show: false },
      {
        Header: <span>{EurestoI18n.t('commun:Intitulé')}</span>,
        accessor: 'libelle',
        minWidth: 200,
        Cell: (row) => {
          return (
            <Grid container justify={'center'} alignItems={'center'} alignContent={'center'} direction={'column'}
                  style={{ height: '100%' }}>
              <span>{row.original.libelle}</span>
            </Grid>
          )
        },
      }, {
        Header: <span>{EurestoI18n.t('commun:Classe/Action FC')}</span>,
        accessor: 'libelle_atelier_classe',
        minWidth: 200,
        Cell: (row) => {
          return (
            <Grid container justify={'center'} alignItems={'center'} alignContent={'center'} direction={'column'}
                  style={{ height: '100%' }}>
              <span>#{row.original.libelle_atelier_classe}</span>
            </Grid>
          )
        },
      }, {
        Header: <span>{EurestoI18n.t('commun:Professeur')}</span>,
        accessor: 'libelle_responsable',
        minWidth: 100,
        Cell: (row) => {
          return (
            <Grid container justify={'center'} alignItems={'center'} alignContent={'center'} direction={'column'}
                  style={{ height: '100%' }}>
              <span>{row.original.libelle_responsable}</span>
            </Grid>
          )
        },
      }, {
        Header: <span>{EurestoI18n.t('commun:Pour le')}</span>,
        accessor: 'date_preparation',
        maxWidth: 100,
        Cell: (row) => {
          return (
            <Grid container justify={'center'} alignItems={'center'} alignContent={'center'} direction={'column'}
                  style={{ height: '100%' }}>
              <span>{moment(row.original.date_preparation).format('DD/MM/YY')}</span>
            </Grid>
          )
        },
      }, {
        Header: <span>{EurestoI18n.t('commun:Pour le')}</span>,
        sortable: false,
        maxWidth: 200,
        Cell: (row) => {
          return (
            (
              row.original.date_validation_besoin_reels
              || row.original.date_saisie_besoins_reels
              || row.original.date_controle
              || row.original.date_confirmation_econome
              || row.original.date_enregistrement_besoins
            )
            &&
            <Grid container justify={'center'} alignItems={'center'} alignContent={'center'} direction={'column'}
                  style={{ height: '100%' }}
                className={
                    row.original.date_validation_besoin_reels && 'DBM-validation_besoins_reels'
                    || row.original.date_saisie_besoins_reels && 'DBM-saisie_besoins_reels'
                    || row.original.date_controle && 'DBM-controle'
                    || row.original.date_confirmation_econome && 'DBM-confirmation_econome'
                    || row.original.date_enregistrement_besoins && 'DBM-enregistrement_besoins'
                  }
            >
              <span>
                {
                  row.original.date_validation_besoin_reels && 'Besoins réels validés '
                  || row.original.date_saisie_besoins_reels && 'Besoins réels saisies '
                  || row.original.date_controle && 'Contrôlée '
                  || row.original.date_confirmation_econome && 'Acceptée '
                  || row.original.date_enregistrement_besoins && 'Enregistrée '
                }
                {moment(
                  row.original.date_validation_besoin_reels
                  || row.original.date_saisie_besoins_reels
                  || row.original.date_controle
                  || row.original.date_confirmation_econome
                  || row.original.date_enregistrement_besoins
                ).format('DD/MM/YY')}</span>
            </Grid>
          )
        },
      },

    ]

    return (
      <Recherche
        showSearch={this.props.showSearch}
        searchComponent={<Search defaultSearch={this.props.defaultSearch}
                                                          search={this.props.search || 'gestion_dbm_' + (this.props.name || '') + User.Entite.get().id}/>}
        view={this.props.view}
        data={this.props.data}
        type={'list'}
        style={this.props.style}
        onClick={this.props.onClick}
        columns={columns}
        search={this.props.search || 'gestion_dbm_' + (this.props.name || '') + User.Entite.get().id}
      />
    )
  }

}



// WEBPACK FOOTER //
// ./app/App/Module/Gestion/Component/Table/Dbm.js